import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";

const GetTopSurveyList = (timeline) => {
  const [topSurveys, setTopSurveys] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getTopSurveys = async () => {
    setIsLoading(true);
    try {
      let data = await TLinkApi.post("dashboards/list/top-survey", timeline);
      setTopSurveys(data.data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTopSurveys();
    // eslint-disable-next-line
  }, [timeline]);
  return { topSurveys, getTopSurveys, isLoading };
};

export default GetTopSurveyList;
